import messages from "@smartmixin/i18n/dist/translations/hu.json";

export default messages;
